import { Heading, Text, VStack } from '@chakra-ui/react';
import React, { useMemo, useRef } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../../../components/atoms/Button';
import { axiosInstance } from '../../../service/axios';

export function PlansIphone() {
  const { token } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const hasRefetchedSubscriptions = useRef(false);

  const { isLoading, isError, isSuccess, error } = useQuery(
    'subscription-mobile-status',
    () =>
      axiosInstance.post('subscription/check-user-subscription/', {
        token,
      }),
    {
      enabled: !!token,
      refetchInterval: 60000,
      retry: 1,
    }
  );
  const data = useMemo(() => {
    const axiosError = error as { response?: { status?: number } } | undefined;
    if (isLoading || (isError && axiosError?.response?.status === 404))
      return {
        title: 'Aguardando confirmação do pagamento!',
        text: 'Se você já tiver realizado o pagamento, aguarde um instante, pois estamos validando a transação.',
        body: <Button onClick={() => navigate('/perfil')}>Cancelar</Button>,
      };

    if (isSuccess)
      return {
        title: 'Compra realizada com sucesso!',
        text: 'Parabéns! Sua compra foi processada com sucesso.',
        body: <Button onClick={() => {
          navigate('/')
        }}>Ir para a página principal</Button>,
      };

    return {
      title: 'Erro na compra',
      text: 'Houve um erro ao processar sua compra. Por favor, tente novamente mais tarde.',
      body: <Button onClick={() => navigate('/perfil')}>Voltar</Button>,
    };
  }, [isLoading, isError, error, isSuccess, navigate]);


  React.useEffect(() => {
    if (isSuccess && !hasRefetchedSubscriptions.current) {
      queryClient.refetchQueries('profileSubscriptions');
      hasRefetchedSubscriptions.current = true;
    }
  }, [isSuccess, queryClient]);


  return (
    <VStack padding="20px 0px" spacing={5}>
      <Heading fontSize={'24px'}>{data.title}</Heading>
      <Text>{data.text}</Text>
      {data.body}
    </VStack>
  );
}
